import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import groups from "./modules/groups";
import events from "./modules/events";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { auth, groups, events }
});
